import { IAsideItem } from '@aca-new/app/pages/main/shared/components/aside/shared/models/interfaces/aside-item.interface';
import { IMAGES } from '@aca-new/app/shared/constants/images.constants';
import { EQimaIconName } from '@qima/ngx-qima';

export const MENU_ITEMS_COMMON: IAsideItem[] = [
  {
    id: 'bookings',
    class: 'ga-click-menu-bookings',
    label: 'APP_ASIDE.COMMON_ITEMS.BOOKINGS',
    iconName: EQimaIconName.ASSIGNMENTS,
    matchPath: '/bookings/',
    path: '/bookings/open',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.BOOKINGS',
  },
  {
    id: 'reports',
    class: 'ga-click-menu-reports',
    label: 'APP_ASIDE.COMMON_ITEMS.REPORTS',
    iconName: EQimaIconName.REPORTS,
    matchPath: '/reports',
    path: '/reports',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.REPORTS',
  },
  {
    id: 'analytics',
    class: 'ga-click-menu-analytics',
    label: 'APP_ASIDE.COMMON_ITEMS.ANALYTICS',
    iconName: EQimaIconName.ANALYTICS,
    matchPath: '/analytics',
    path: '/analytics',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.ANALYTICS',
  },
  {
    id: 'suppliers',
    class: 'ga-click-menu-suppliers',
    label: 'APP_ASIDE.COMMON_ITEMS.SUPPLIERS',
    iconName: EQimaIconName.SUPPLIER_FACTORY,
    matchPath: '/suppliers',
    path: '/suppliers',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.SUPPLIERS',
  },
  {
    id: 'checklists',
    label: 'APP_ASIDE.COMMON_ITEMS.CHECKLISTS',
    iconName: EQimaIconName.CHECKLIST,
    matchPath: '/checklists',
    path: '/checklists',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.CHECKLISTS',
  },
  {
    id: 'non-conformances',
    class: 'ga-click-menu-analytics',
    label: 'ANALYTICS.NON_CONFORMANCE.CONSULTANT_DASHBOARD.NON_CONFORMANCE',
    iconName: EQimaIconName.ANALYTICS,
    matchPath: '/non-conformances',
    path: '/non-conformances',
    tooltip: 'ANALYTICS.NON_CONFORMANCE.CONSULTANT_DASHBOARD.NON_CONFORMANCE',
  },
  {
    id: 'units',
    label: 'APP_ASIDE.COMMON_ITEMS.UNITS',
    iconName: EQimaIconName.SUPPLIER_FACTORY,
    matchPath: '',
    path: '',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.UNITS',
  },
  {
    id: 'supplierDocuments',
    label: 'APP_ASIDE.COMMON_ITEMS.SUPPLIER_DOCUMENTS',
    iconName: EQimaIconName.DOCUMENT,
    matchPath: '/supplier-documents',
    path: '/supplier-documents',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.SUPPLIER_DOCUMENTS',
  },
  {
    id: 'network',
    label: 'APP_ASIDE.COMMON_ITEMS.NETWORK',
    iconName: EQimaIconName.NETWORK,
    matchPath: '/network',
    path: '/network',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.NETWORK',
  },
  {
    id: 'payments',
    class: 'ga-click-menu-payments',
    label: 'APP_ASIDE.COMMON_ITEMS.PAYMENTS',
    iconName: EQimaIconName.PAYMENT,
    matchPath: '/payments/',
    path: '/payments/unpaid',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.PAYMENTS',
  },
  {
    id: 'broker',
    label: 'REPORTS.BROKER',
    iconName: EQimaIconName.REPORTS,
    matchPath: '/broker',
    path: '/broker',
    tooltip: 'REPORTS.BROKER',
  },
  {
    id: 'iqInspectionPlanner',
    class: 'ga-click-menu-iq-inspection-planner app-aside-nav-style--qima-iq',
    label: 'APP_ASIDE.COMMON_ITEMS.INSPECTION_PLANNER',
    iconSrc: IMAGES.qimaIqAsideMenuIcon,
    iconName: EQimaIconName.INSPECTION,
    matchPath: '/iq/inspection-planner',
    path: '/iq/inspection-planner',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.INSPECTION_PLANNER',
  },
];

export const MENU_ITEMS_LIFE_SCIENCE: IAsideItem[] = [
  {
    id: 'home',
    visible: true,
    label: 'LIFE_SCIENCE.HOME.HOME',
    iconName: EQimaIconName.HOME,
    matchPath: '/life-sciences',
    path: '/life-sciences',
    tooltip: 'LIFE_SCIENCE.HOME.HOME',
  },
  {
    id: 'studies',
    visible: true,
    label: 'LIFE_SCIENCE.STUDIES.STUDIES',
    iconName: EQimaIconName.INSPECTION,
    matchPath: '/life-sciences/studies',
    path: '/life-sciences/studies',
    tooltip: 'LIFE_SCIENCE.STUDIES.STUDIES',
  },
  {
    id: 'reports',
    visible: true,
    label: 'LIFE_SCIENCE.REPORTS.REPORTS',
    iconName: EQimaIconName.REPORTS,
    matchPath: '/life-sciences/reports',
    path: '/life-sciences/reports',
    tooltip: 'LIFE_SCIENCE.REPORTS.REPORTS',
  },
];

export const MENU_ITEMS_BROKER_TYPE: IAsideItem[] = [
  {
    id: 'analytics',
    visible: true,
    label: 'APP_ASIDE.COMMON_ITEMS.ANALYTICS',
    iconName: EQimaIconName.ANALYTICS,
    matchPath: '/analytics',
    path: '/analytics',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.ANALYTICS',
  },
  {
    id: 'broker',
    visible: true,
    label: 'APP_ASIDE.COMMON_ITEMS.REPORTS',
    iconName: EQimaIconName.REPORTS,
    matchPath: '/broker',
    path: '/broker',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.REPORTS',
  },
];
